module.exports = __webpack_public_path__ + "img/butterfly.3ae64a29.svg";